import { prefetchBaseQuery } from '@src/corelib/query';


export default function prefetchQuery(url, client, params) {
  return prefetchBaseQuery(url, client, params);
}

